import React from "react"
import { Grid } from "@mui/material"

import { AppCardTitle, AppCrudTable } from "@components"
import { userSettingOfficesGroupData } from "../@signals"
import { actionsColumn, nameColumn, officesColumn } from "./columns"
import UserSettingOfficesGroupDrawer from "./Drawer"
import { isTourDemoActive } from "@signals/app"
import UserSettingOfficesGroupTabButton from "./Button"


export default function UserSettingOfficesGroupTab() {

	return <Grid container spacing={1}>
		{(!isTourDemoActive.value || !!userSettingOfficesGroupData.value?.length) && <Grid item xs={12}>
			<AppCrudTable
				// The tab's create button with the table's own actions, as every list of the app
				options={{ customToolbar: () => <UserSettingOfficesGroupTabButton/> }}
				title={<AppCardTitle icon="building" title="Your Offices Group"/>}
				data={userSettingOfficesGroupData.value}
				columns={[
					nameColumn(),
					officesColumn(),
					actionsColumn()
				]}
			/>
		</Grid>}

		<UserSettingOfficesGroupDrawer />
	</Grid>
}